import { Directive, HostBinding, Input, OnChanges } from '@angular/core'

@Directive({
  selector: 'a[appNoCache]',
})
export class NoCacheDirective implements OnChanges {
  @HostBinding('attr.href')
  hrefAttr = ''

  @Input()
  href: string

  private buildUncachedLink(link: string) {
    const now = new Date().getTime()
    return `${link}?time=${now}`
  }

  ngOnChanges() {
    this.hrefAttr = this.href ? this.buildUncachedLink(this.href) : this.href
  }
}
